export const COUNTRIES = [
  {
    id: 'NL',
    value: 'netherlands',
  },
  {
    id: 'BE',
    value: 'belgium',
  },
  {
    id: 'GE',
    value: 'germany',
  },
  {
    id: 'FR',
    value: 'france',
  },
  {
    id: 'DE',
    value: 'denmark',
  },
  {
    id: 'AU',
    value: 'austria',
  },
  {
    id: 'PL',
    value: 'poland',
  },
  {
    id: 'US',
    value: 'united_states',
  },
  {
    id: 'UK',
    value: 'united_kingdom',
  },
  {
    id: 'SE',
    value: 'sweden',
  },
];

export interface Country {
  id: string;
  value: string;
}
